module.exports = __webpack_public_path__ + "img/business_pay_03.ea7598d5.png";